import React, { useEffect, useState } from "react";
import "../style/signup.scss";
import { Icon } from "@iconify/react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Signup = () => {
  const [userName, setUserName] = useState();
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [phone, setPhone] = useState();

  const navigate = useNavigate();
  const location = useLocation();

  const handleloginNavigate = () => {
    navigate("/login");
  };

  console.log("kdkdjsabbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbb");

  var authToken = JSON.parse(localStorage.getItem("bearerToken"));

  useEffect(() => {
    if (authToken) {
      navigate("/dashboard");
    }
  }, []);

  const handleButtonClick = () => {
    axios
      .post(`${process.env.REACT_APP_API_URL}/customer/signup`, {
        userName: formData.username,
        phone: formData.phone,
        email: formData.email,
        password: formData.password,
      })
      .then((res) => {
        console.log("Response from server:", res.data.data);
        navigate("/login");
        toast.success("User registered successfully!");
      })
      .catch((err) => {
        console.log("Error:", err);
        toast.error(`Error : ${err?.response?.data}`);
      });
  };

  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const [passwordMatchError, setPasswordMatchError] = useState("");
  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

  const [formData, setFormData] = useState({
    username: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
  });

  const [formErrors, setFormErrors] = useState({
    username: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
  });

  const showToast = (message) => {
    toast.error(message, {
      position: toast.POSITION.TOP_CENTER,
    });
  };

  const handleInputChange = (field, value) => {
    if (field === "phone" && value.length > 12) {
      return;
    }

    setFormData({
      ...formData,
      [field]: value,
    });
    // Clear errors when the user starts typing
    setFormErrors({
      ...formErrors,
      [field]: "",
    });
  };

  const handlePasswordChange = (event) => {
    const newPassword = event.target.value;
    setFormData({
      ...formData,
      password: newPassword,
    });
    // Password length validation
    // if (newPassword.length > MAX_PASSWORD_LENGTH) {
    //   showToast(`Password cannot exceed ${MAX_PASSWORD_LENGTH} characters.`);
    // }
  };

  const togglePasswordVisibility = () => {
    setFormData({
      ...formData,
      passwordVisible: !formData.passwordVisible,
    });
    setPasswordVisible(!passwordVisible);
  };

  const toggleConfirmPasswordVisibility = () => {
    setFormData({
      ...formData,
      confirmPasswordVisible: !formData.confirmPasswordVisible,
    });
    setConfirmPasswordVisible(!confirmPasswordVisible);
  };

  const handleSignup = () => {
    const { username, email, phone, password, confirmPassword } = formData;
    const newFormErrors = {};

    if (!username || !email || !phone || !password || !confirmPassword) {
      showToast("Fields are empty");
      return;
    }

    if (!emailRegex.test(email)) {
      newFormErrors.email = "Invalid email format";
    }

    // if (formData.phone.length !== 12) {
    //   newFormErrors.phone = "Phone number must be 11 digits";
    // }

    // if (password.length < 8 || password.length > 20) {
    //   newFormErrors.password = "Password must be at least 8 and 20 characters long.";
    // }

    if (confirmPassword !== password) {
      newFormErrors.confirmPassword = "Passwords don't match";
    }
    setFormErrors(newFormErrors);

    if (Object.keys(newFormErrors).length === 0) {
      console.log("Inside validae error function");

      handleButtonClick();
      // alert("Sign up successful!");
      // navigate("/plan");
    }
  };

  console.log("Form Errors :", formErrors);

  function validatePassword() {
    var passwordInput = document.getElementById("password");
    var passwordError = document.getElementById("passwordError");
    var password = passwordInput.value;
    // Remove spaces from the password
    var passwordWithoutSpaces = password.replace(/\s/g, "");
    if (password !== passwordWithoutSpaces) {
      passwordInput.value = passwordWithoutSpaces;
    }
    // Check if the password contains any space character
    if (password.includes(" ")) {
      passwordError.textContent = "Password cannot contain spaces.";
      passwordInput.setCustomValidity("Invalid input");
    } else {
      passwordError.textContent = "";
      passwordInput.setCustomValidity("");
    }
  }

  return (
    <>
      <div className="signup-banner">
        <div className="content-left">
          <div className="content-left-mainDiv">
            <p className="content-left-heading">Group LanDev AI</p>
            <span>
              {" "}
              Going to Help to Plan your
              <br />
              <span>Construction</span>
            </span>
          </div>
        </div>
        <div className="content-right">
          <div className="content-right-container">
            <p>Sign up</p>
            <input
              type="text"
              placeholder="Username"
              value={formData.username}
              onChange={(e) => handleInputChange("username", e.target.value)}
              className="input-fields"
              style={{
                border: formErrors.username ? "1px solid red" : "1px solid #ccc",
              }}
            />
            <span style={{ color: "red" }} className="span">
              {formErrors.username}
            </span>

            <input
              type="email"
              placeholder="Email"
              value={formData.email}
              onChange={(e) => handleInputChange("email", e.target.value)}
              className="input-fields"
              style={{
                border: formErrors.email ? "1px solid red" : "1px solid #ccc",
              }}
            />
            <span style={{ color: "red" }} className="span">
              {formErrors.email}
            </span>

            <input
              type="number"
              placeholder="Phone no"
              value={formData.phone}
              onChange={(e) => handleInputChange("phone", e.target.value)}
              className="input-fields"
              style={{
                border: formErrors.phone ? "1px solid red" : "1px solid #ccc",
              }}
            />
            <span style={{ color: "red" }} className="span">
              {formErrors.phone}
            </span>

            <div className="pass-wrapper">
              <input
                type={passwordVisible ? "text" : "password"}
                placeholder="Password"
                className="input-fields"
                name="password"
                oninput="validatePassword()"
                value={formData.password}
                onChange={(e) => handleInputChange("password", e.target.value)}
                onCopy={(e) => e.preventDefault()}
                style={{
                  border: formErrors.password ? "1px solid red" : "1px solid #ccc",
                }}
              />

              {passwordVisible ? (
                <Icon icon="el:eye-close" color="#666" width="49" height="30" hFlip={true} className="eye" opacity="1" onClick={togglePasswordVisibility} />
              ) : (
                <Icon icon="bi:eye-fill" color="#666" width="49" height="30" hFlip={true} className="eye" opacity="1" onClick={togglePasswordVisibility} />
              )}
              <span style={{ color: "red" }} className="span">
                {formErrors.password}
              </span>
            </div>

            <span style={{ color: "red" }} className="span">
              {passwordMatchError}
            </span>

            <div className="pass-wrapper">
              <input
                type={confirmPasswordVisible ? "text" : "password"}
                placeholder="Confirm Password"
                className="input-fields"
                value={formData.confirmPassword}
                onChange={(e) => handleInputChange("confirmPassword", e.target.value)}
                onCopy={(e) => e.preventDefault()}
                style={{
                  border: formErrors.confirmPassword ? "1px solid red" : "1px solid #ccc",
                }}
              />
              {/* <Icon icon="bi:eye-fill" color="#666" width="49" height="30" hFlip={true} className="eye" opacity="1" onClick={toggleConfirmPasswordVisibility} /> */}
              {confirmPasswordVisible ? (
                <Icon
                  icon="el:eye-close"
                  color="#666"
                  width="49"
                  height="30"
                  hFlip={true}
                  className="eye"
                  opacity="1"
                  onClick={() => {
                    toggleConfirmPasswordVisibility();
                  }}
                />
              ) : (
                <Icon
                  icon="bi:eye-fill"
                  color="#666"
                  width="49"
                  height="30"
                  hFlip={true}
                  className="eye"
                  opacity="1"
                  onClick={() => {
                    toggleConfirmPasswordVisibility();
                  }}
                />
              )}
              <span style={{ color: "red" }} className="span">
                {formErrors.confirmPassword}
              </span>
            </div>

            <span style={{ color: "red" }} className="span">
              {passwordMatchError}
            </span>

            <div className="btnWrapper">
              <button
                className="gradient-btn-yellow"
                onClick={() => {
                  handleSignup();
                }}
              >
                Sign up
              </button>
              <Link to="/login">
                <button
                  className="loginBtn"
                  onClick={() => {
                    handleloginNavigate();
                  }}
                >
                  Log in
                </button>
              </Link>
            </div>
            <p className="signIn-text">Or sign in with</p>
            <div className="social-media-wrapper">
              <div className="social-icon-box">
                <img src="../../images/home/google.png" alt="" className="google-icon" />
              </div>
              <div className="social-icon-box">
                <img src="../../images/home/facebook.png" alt="" className="google-icon" />
              </div>
              <div className="social-icon-box">
                <img src="../../images/home/twitter.png" alt="" className="google-icon" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Signup;
